import { render, staticRenderFns } from "./theclassEdit.vue?vue&type=template&id=14451195&scoped=true"
import script from "./theclassEdit.vue?vue&type=script&lang=js"
export * from "./theclassEdit.vue?vue&type=script&lang=js"
import style0 from "./theclassEdit.vue?vue&type=style&index=0&id=14451195&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14451195",
  null
  
)

export default component.exports